import React from "react";
import "./MainContent.scss";
export default function MainContent({ children }) {
  return (
    <section
      className={`relative grid grid-cols-1 min-h-screen portal-shell main-content gap-4_`}
    >
      {children}
    </section>
  );
}
